module.exports = __webpack_public_path__ + "static/media/thumbnail-IMG_1051.4b4cfa41.jpg";